import React from 'react';

import styles from './ImageButton.module.css';

const ImageButton = ({
	id,
	name,
	label,
	onClick,
	shapeName,
	containerStyles,
	isActive,
	isAlert,
}) => {
	const activeStyle = isActive
		? isAlert
			? styles.active_button_alert
			: styles.active_button
		: '';
	return (
		<div style={containerStyles} className={styles.container}>
			<button
				type="button"
				className={`
					${styles.circle_button}
					${styles[`${shapeName}`]}
					${activeStyle}`}
				id={id}
				onClick={onClick}
				name={name}
			/>
			<span className={styles.button_under_label}>{label}</span>
		</div>
	);
};

export default ImageButton;
